import React from 'react';
import Serializer, {
  type SerializeArguments,
  type DeserializeArguments,
} from './Serializer';
import { isHTMLElementNode } from '../helpers/serializerHelpers';
import { type AttachmentElement } from '../../types/aha-editor';
import { isAttachmentElement } from '../../types/guards';

class SerializerAttachment extends Serializer {
  static deserialize({
    el,
    options,
  }: DeserializeArguments): AttachmentElement | undefined {
    if (
      !isHTMLElementNode(el) ||
      el.tagName.toLowerCase() !== 'a' ||
      !el.getAttribute('download') // Use the download attribute to identify attachments.
    )
      return;

    const href = el.getAttribute('href');
    if (!href || href.length === 0) return;
    if (!options.allowedMediaRegex || !options.allowedMediaRegex.exec(href))
      return;

    let mimeType = el.dataset.mimetype;
    if (!mimeType) mimeType = 'application/octet-stream';

    return {
      type: 'attachment',
      children: [{ text: '' }],
      media_src: href,
      attachment_mimeType: mimeType,
      attachment_fileName: el.getAttribute('download') || '',
    };
  }

  static serialize({ node, children }: SerializeArguments): React.ReactNode {
    if (!isAttachmentElement(node)) return;

    const { media_src, attachment_mimeType, attachment_fileName } = node;

    return (
      <a
        download={attachment_fileName}
        href={media_src}
        data-mimetype={attachment_mimeType}
      >
        {attachment_fileName}
      </a>
    );
  }
}

export default SerializerAttachment;
